<script setup>
import { createHead } from 'unhead';
import { RouterView } from 'vue-router';
import { computed, onMounted } from 'vue';
import { useStore } from 'vuex';
import NavSidebar from './components/NavSidebar.vue';

createHead().push({});

// Store
const store = useStore();

// Computed
const retractedSidebar = computed(() => store.state.retractedSidebar);

onMounted(() => {
    // Load ID blacklist once for privacy filtering
    const idBlacklistElement = document.getElementById('idBlackListData');
    if (idBlacklistElement && idBlacklistElement.textContent) {
        try {
            const blacklist = JSON.parse(idBlacklistElement.textContent);
            store.commit('setIdBlacklist', blacklist);
        } catch (e) {
            console.error('Failed to parse ID blacklist:', e);
        }
    }

    if (!document.getElementById('authData').textContent) {
        return;
    }

    const authData = JSON.parse(document.getElementById('authData').textContent);
    if (!authData || !authData.loggedIn) {
        return;
    }
    store.commit('auth', authData);

    // First load
    // if (localStorage.getItem('firstLoadApril') === 'true' || authData.banned) {
    //     return;
    // }

    // store.commit('addConfirm', {
    //     id: "hello-april",
    //     text: `Dark mode is available! You can enable it in the footer if it's not already the default on your system.\n\n___\n\nThis message won't appear again if you click Confirm.`,
    //     callback: (result) => {
    //         if (!result) return;

    //         localStorage.setItem('firstLoadApril', 'true');
    //     }
    // });
});
</script>

<template>
    <NavSidebar />

    <div id="content" class="relative pb-10 md:pb-0" :class="{'md:pl-64': !retractedSidebar, 'md:pl-20': retractedSidebar}">
        <RouterView />
    </div>

    <notification-container />
</template>
